
import React from "react"
import { useNavigate } from "react-router-dom";
import {useEffect, useState} from "react";
import { CircleChart  } from './components/CricleChart';

function mapStocks (data) {
    let stocks =[];
  
    if (data !== null) { 
      for (let i = 0; i< data.stocks.length; i++){
        let newStock = {Ticker:data.stocks[i].Ticker ,Company:data.stocks[i].CompanyName, Rating:data.stocks[i].Rating, Score:data.stocks[i].Score, Price: +data.stocks[i].Price, ChangeUSD: +data.stocks[i].PriceChange, LongShort: +data.stocks[i].LongShort, Weight: +data.stocks[i].Weight, LastUpdate: data.stocks[i].LastUpdate};
          stocks = [...stocks , newStock];
      }
    }
    console.log (stocks);
    return stocks;
  }

const StockList = (props) => {

    const strategy = props.strategy;
    const [stocks, setStocks] = useState([]);
    let navigete = useNavigate();

    const handleDetails = (e) => {
        navigete('/stock/'+e.target.value);
    }

  function fetchRecommendation(url)  {

    const abortCtrl   = new AbortController();

    const fetchData= async () => {
          console.log("fetch recommendation... "); 
          try {
              const response = await fetch(url,{signal: abortCtrl.signal});
              const json = await response.json();
              setStocks(mapStocks(json));
              console.log("fetch recommendation done");  
          } catch (error) {
              if (error.name === 'AbortError'){
                  console.log("aborted", error);
              }
              else {
                  console.log("error", error);
              }
          }
    };
  
    fetchData();
  
    return () => abortCtrl.abort();
  }


  useEffect(() => {
    
    const server = "https://app.cuetraders.com";
    let url = server+"/api/get_daily_recommendations.php?strategy="+strategy;
    fetchRecommendation(url);

  }, [strategy]);

    return (<div> {stocks &&
        stocks.map((item, idx)=> (
        <div className="col-lg-3 col-sm-4 col-xs-10">
            <div className="panel panel-default">
            <div className="panel-heading comparePanelsHeaderStyle"> 

            <div align="left">
            <div className="sm-company">{item.Company}</div>
            <div className="sm-symbol">{item.Ticker}</div>
            <div className="sm-quote-div">
            <span className="sm-quote">${item.Price}</span>
            <i> </i>
            <span className="sm-change-div">
                { (+item.ChangeUSD >= 0) && <span className="sm-change-green">+{item.ChangeUSD}</span>}
                { (+item.ChangeUSD < 0) &&  <span className="sm-change-red">({item.ChangeUSD})</span>} 
            </span>
            </div>
            </div>
            <div className="SFscore">
                {(+(item.Rating) >= 1) && <i className="fa fa-star"></i> }
                {(+(item.Rating) >= 2) && <i className="fa fa-star"></i> }
                {(+(item.Rating) >= 3) && <i className="fa fa-star"></i> }
                {(+(item.Rating) >= 4) && <i className="fa fa-star"></i> }
                {(+(item.Rating) >= 5) && <i className="fa fa-star"></i> }
            </div>
            </div>

            <div className="panel-heading comparePanelsHeaderStyle">
              <div className="l-span-xs-6" align="center">
              <span className="sm-symbol" >Score</span> <span data-percent="50" className="sm-quote"><CircleChart score={Math.round(item.Score)} size='50px' textColor="white"></CircleChart></span>
              </div>

              <div className="l-span-xs-6" align="center">
              <span className="sm-symbol" >Match</span> <span data-percent="50" className="sm-quote"><CircleChart score={Math.round(20*item.Weight)} size='50px' textColor="white"></CircleChart></span>
              </div>

              <div align="center ">
              <p> ... </p>
              <button type="button" className="btn-normal"  onClick={(e) => handleDetails(e)} name="StockDetails" value={item.Ticker}>Details</button>
              </div>
            </div>

            
          </div>
        </div>))
      }</div>);
}

export default StockList;